import { BrowserModule } from '@angular/platform-browser';
import { NgModule, APP_INITIALIZER } from '@angular/core';
import { HttpClientModule } from '@angular/common/http';

import { FormsModule, ReactiveFormsModule } from '@angular/forms';

import { AppComponent } from './app.component';
import { TrialFormComponent } from './components/trial-form/trial-form.component';
import { OrgAddressComponent } from './components/organization-address/organization-address.component';

import { CountryService } from './services/country/country.service';
import { ICountryService } from './services/country/country.service.interface';

import { FormStepsComponent } from './components/form-steps/form-steps.component';
import { ContactInformationComponent } from './components/contact-information/contact-information.component';
import { OrganizationInformationComponent } from './components/organization-information/organization-information.component';
import { DefaultTextInputComponent } from './components/default-text-input/default-text-input.component';
import { OrganizationAccountComponent } from './components/organization-account/organization-account.component';
import { ITrialService } from './services/Trial/trial.service.interface';
import { TrialService } from './services/Trial/trial.service';
import { CreateAccountComponent } from './components/create-account/create-account.component';
import { AppRoutingModule } from './app-routing.module';
import { ProductInfoComponent } from './components/product-info/product-info.component';
import { TrialConfirmationComponent } from './components/trial-confirmation/trial-confirmation.component';
import { ConfigurationService } from './services/configuration.service';
import { AuthCallbackComponent } from './components/auth-callback/authCallback.component';
import { AuthenticationService } from './services/auth.service';
import { ErrorComponent } from './components/error/error.component';
import { PinnacleTrialConfirmationComponent } from './components/pinnacle-trial-confirmation/pinnacle-trial-confirmation.component';
import { TrialProductInfoComponent } from './components/trial-product-info/trial-product-info.component';
import { TrialRegisterAccountComponent } from './components/trial-register-account/trial-register-account.component';
import { PaymentInformationComponent } from './components/payment-information/payment-information.component';
import { PaymentService } from './services/payment/payment.service';
import { IStateService } from './services/state/state.service.interface';
import { StateService } from './services/state/state.service';


@NgModule({
  declarations: [
    AppComponent,
    TrialFormComponent,
    OrgAddressComponent,
    FormStepsComponent,
    ContactInformationComponent,
    OrganizationInformationComponent,
    DefaultTextInputComponent,
    OrganizationAccountComponent,
    CreateAccountComponent,
    ProductInfoComponent,
    TrialConfirmationComponent,
    AuthCallbackComponent,
    ErrorComponent,
    PinnacleTrialConfirmationComponent,
    TrialProductInfoComponent,
    TrialRegisterAccountComponent,
    PaymentInformationComponent
  ],
  imports: [
    BrowserModule,
    FormsModule,
    ReactiveFormsModule,
    HttpClientModule,
    AppRoutingModule
  ],
  providers: [
    { provide: ICountryService, useClass: CountryService },
    { provide: IStateService, useClass: StateService },
    { provide: ITrialService, useClass: TrialService },
    ConfigurationService,
    {
      provide: APP_INITIALIZER,
      useFactory: appConfigServiceFactory,
      deps: [ConfigurationService], multi: true
    }
    ,AuthenticationService
    ,PaymentService
  ],
  bootstrap: [AppComponent]
})
export class AppModule { }

export function appConfigServiceFactory(configService: ConfigurationService) {
  return () => configService.loadConfigurationData();
}
